<template>
    <section class="banner-sec dddd primaryLightBg position-relative overflow-hidden">
        <div class="container">
            <div class="row">
                <div class="col-md-6 d-flex justify-content-center align-items-center">
                    <div class="text-sec">
                        <img class="img-fluid mb-5 logoimg" src="/static/fxView/images/lp/fxviewlogo.svg"
                            data-aos="fade-down" data-aos-duration="700" data-aos-delay="300" />
                        <h1 class="titleColor fw-bold mb-0" data-aos="fade-up" data-aos-duration="600"
                            data-aos-delay="500">
                            <span class="acc">{{$t("demo_account.open_a")}}</span><br />
                            <span class="textPrimary">{{$t("demo_account.free_demo")}}</span><br />
                            <span class="acc">{{$t("demo_account.account_on")}}</span>
                        </h1>
                        <h2 class="fs24 mt-2 pb-3 titleColor fw-medium mb-0 position-relative" data-aos="fade-up"
                            data-aos-duration="600" data-aos-delay="700">
                            <!-- {{$t("demo_account.mt4")}}, {{$t("demo_account.mt5")}} {{$t("demo_account.or")}} {{$t("demo_account.act")}}. -->
                        </h2>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="d-flex form-box-outer justify-content-center position-relative mt-5 mt-md-0" data-aos="fade-up" data-aos-duration="600" data-aos-delay="900">
                        <div class="form-box mx-auto overflow-hidden position-relative">
                            <div class="loader-wrap openacc" v-if="pageLoader">
                                <img src="/static/fxView/images/lp/loaderimg.svg" />
                            </div>
                            <h3 class="fs36 fw-semiBold mb-2 mb-lg-3 pt-1 titleColor mb-1">
                                {{$t("demo_account.register_form_open_an_account")}}
                            </h3>
                            <p class="fs18 mb-4 pb-1 pb-lg-3 textPrimary">
                                {{$t("demo_account.register_form_will_take_minut")}}
                            </p>
                            <form class="register-form" @submit.prevent="" ref="regform">
                                <!-- <p v-if="regerror != ''" class="alert alert-danger" v-html="regerror"></p> -->
                                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                                <div class="mb-4">
                                    <select class="form-select cmn-input h56" name="Residence Country" v-model="res_country" v-validate="'required'">
                                        <option disabled value="">{{$t("demo_account.register_form_select_residence_country")}}</option>
                                        <option v-for="(val, key) in residence_country" :value="val.iso2"> {{ val.name }} </option>
                                    </select>
                                    <div class="error" v-for="error in errors.collect('Residence Country')">{{ error }}</div>
                                </div>
                                <div class="mb-4">
                                    <input type="email" name="Email" class="form-control cmn-input h56" placeholder="Enter Email Address" v-model="email" v-validate="'required|email'" />
                                    <!-- <div name="Email" style="color: red" /> -->
                                    <div class="error" v-for="error in errors.collect('Email')">{{ error }}</div>

                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mb-4">
                                        <div class="input-wrap position-relative">
                                            <input :type="showpassword?'text':'password'" name="Password" v-model="password" class="form-control cmn-input h56" placeholder="Enter Password" v-validate="{ required: true, min: 6, max: 12, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,12}$/, }" />
                                            <span class="icon-wrap" @click="showpassword ^= true">
                                                <feather :type="showpassword?'eye':'eye-off'" class="toggle-password"></feather>
                                            </span>
                                        </div>
                                        <div class="error" v-for="error in errors.collect('Password')">{{ error }}</div>
                                    </div>
                                    <div class="col-lg-6 mb-4">
                                        <div class="input-wrap position-relative">
                                            <input :type="showpassword2? 'text' : 'password'" name="Confirm Password" class="form-control cmn-input h56" placeholder="Confirm Password" v-model="confirm_password" v-validate="{ required: true, confirmed: password }" />
                                            <span class="icon-wrap" @click="showpassword2 ^= true">
                                                <feather :type="showpassword2?'eye':'eye-off'" class="toggle-password"></feather>
                                            </span>
                                        </div>
                                        <div class="error" v-for="error in errors.collect('Confirm Password')">{{ error }}</div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check mx-auto">
                                        <input class="form-check-input" type="checkbox" name="Privacy Policy" v-model="Checkbox" value="Checkbox" id="flexCheckDefault" v-validate="'required'" />
                                        <label class="form-check-label lh-1 text-black fw-normal mb-0" for="flexCheckDefault">
                                            {{$t("demo_account.register_form_privacy_agree")}} <a :href="$env_var.privacyPolicyLinkNew" class="textPrimary text-decoration-none link">{{$t("demo_account.register_form_privacy_policy")}}</a>
                                        </label>
                                        <div class="error" v-for="error in errors.collect('Privacy Policy')">{{ error }}</div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between flex-wrap flex-lg-nowrap mt-4">
                                    <button type="submit" class="btn primaryBtn h56 text-white text-uppercase fw-semiBold pt-1 px-5 fs22" @click="create_lead()">
                                        <span>{{$t("demo_account.register")}}</span>
                                    </button>
                                    <p class="fs18 mb-0 text-end mt-4 mt-lg-0">
                                        Have an account?
                                        <router-link class="textPrimary fw-semiBold pt-1 text-decoration-none" to="/" target="_blank">
                                        {{$t("demo_account.login")}}</router-link>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- <div class="form-sec bg-white mt-0 p-1 otp-form-wrap" data-aos="fade-up" data-aos-duration="600" data-aos-delay="500" v-else>
                        <form class="form-holder whiteBg text-center" @submit.prevent ref="regform">
                            <div class="img-wrap mx-auto mb-4" style="width: 150px;">
                                <img src="/static/fxView/images/lp/otp_img.jpg" />
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-10 mb-1 mx-auto">
                                    <label class="mb-2" for="country">{{$t("demo_account.register_form_otp_msg")}}</label>
                                    <input class="form-control" type="text" v-model="otp" name="OTP" v-validate="'required'" />
                                    <div class="error" v-for="error in errors.collect('OTP')">{{ error }}</div>

                                    <p class="text-right mt-2" @click="resend()"><span class="textPrimary cursor-pointer">Resend Otp</span></p>
                                </div>
                            </div>
                            <div class="btn-holder py-3">
                                <button type="submit" name="" class="btn primaryBtn h56 text-white text-uppercase fw-semiBold pt-1 px-5 fs22 mx-auto" @click="verify_lead()"><span>{{$t("submit")}}</span></button>
                            </div>
                        </form>
                    </div> -->
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    const crypto = require("crypto");
    import * as types from "@/types";
    import { mapActions } from "vuex";
    import language from "../../shared/language_before_login";
    import { fxViewMixins } from "@/plugins/fxView";
    import VueRecaptcha from "vue-recaptcha";
    export default {
        name: "Register",
        mixins: [fxViewMixins],
        data() {
            return {
                pageLoader: false,
                response_msg: "",
                msg_type: "",
                residence_country: [],
                res_country: "",
                account_type: "0",
                accountType: [
                    { id: "0", name: "Individual" },
                    { id: "1", name: "Joint" },
                    { id: "2", name: "Corporate" },
                ],
                // insertId: "-1",
                username: "",
                email: "",
                name: "",
                password: "",
                confirm_password: "",
                mobile_number: "",
                otp: "",
                error_msg_password: "",
                submitted: false,
                submittedOtp: false,
                showpassword: false,
                userCountry: "N/A",
                passwordErr: false,
                numberValid: true,
                numberWithCountry: "",
                captchaVerified: false,
                captchaToken: "",
                captachErr: false,
                IBREFERLINK: "",
                tabActive: "",
                admin_id: "0",
                rm_id: "0",
                showpassword2: false,
                Checkbox: false,
            };
        },
        components: {
            appLanguage: language,
            VueRecaptcha,
        },
        methods: {
            tabActiveFun(getData) {
                this.tabActive = getData;
            },
            hideFunc() {
                this.response_msg = "";
                this.msg_type = "";
            },
            switchVisibility() {
                this.showpassword = !this.showpassword;
                if (this.showpassword) {
                    this.inputtype = "text";
                    this.iconType = "eye";
                } else {
                    this.inputtype = "password";
                    this.iconType = "eye-off";
                }
            },
            switchVisibility1() {
                this.showpassword2 = !this.showpassword2;
                if (this.showpassword2) {
                    this.inputtype2 = "text";
                    this.iconType2 = "eye";
                } else {
                    this.inputtype2 = "password";
                    this.iconType2 = "eye-off";
                }
            },

            ...mapActions({
                _runUserSignUp: types.RUN_USER_SIGNUP,
                _runVerifyLeadOtp: types.RUN_VERIFY_LEAD_OTP,
                _runGetUserIp: types.RUN_GET_USER_IP,
            }),
            onCaptchaVerified: function (recaptchaToken) {
                const self = this;

                this.captchaVerified = true;
                this.captchaToken = recaptchaToken;
                // self.$refs.recaptcha.reset();
            },

            onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
            },
            resend() {
                const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let hashedstr = mykey.update(this.password, "utf8", "hex");
                hashedstr += mykey.final("hex");
                let input_json = {
                    globalParams: {
                        // "name" : this.name,
                        email: this.email,
                        account_type: this.account_type,
                        mobile: this.numberWithCountry,
                        password: hashedstr,
                        captchaToken: this.captchaToken,
                        IBREFERLINK: this.IBREFERLINK,
                        residence_country: this.res_country,
                    },
                    localParams: { parameter: this, page: "resend" },
                };
                this._runUserSignUp(input_json);
            },
            updatedText(e) {
                this.numberWithCountry = e.formattedNumber;
                this.numberValid = e.isValid;
            },
            create_lead() {
                const _that = this;
                _that.submitted = true;

                const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let hashedstr = mykey.update(_that.password, "utf8", "hex");
                hashedstr += mykey.final("hex");

                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/;
                        if (!regex.test(_that.password)) {
                            _that.passwordErr = true;
                            _that.submitted = false;
                        }/* else if (!this.captchaVerified) {
                            _that.captachErr = true;
                            _that.submitted = false;
                        }*/ else {
                            _that.passwordErr = false;
                            _that.submitted = false;
                            let input_json = {
                                globalParams: {
                                    // "name" : this.name,
                                    email: _that.email,
                                    account_type: _that.account_type,
                                    mobile: _that.numberWithCountry,
                                    admin_id: _that.admin_id,
                                    rm_id: _that.rm_id,
                                    password: hashedstr,
                                    captchaToken: this.captchaToken,
                                    residence_country: _that.res_country,
                                    IBREFERLINK: _that.IBREFERLINK,
                                    ip_country: this.userCountry,
                                },
                                localParams: { parameter: _that },
                            };

                            //===========in use==============
                            if (_that.$cookies.get("investing_ref")) {
                                input_json.globalParams.investing_ref = _that.$cookies.get("investing_ref");
                            }
                            if (_that.$cookies.get("refLink") && _that.$cookies.get("refRm")) {
                                input_json.globalParams.rm_id = _that.$cookies.get("refRm");
                                input_json.globalParams.admin_id = _that.$cookies.get("refLink");
                            } else if (_that.$cookies.get("IBREFERLINK")) {
                                let decrpyLinRm = window.atob(_that.$cookies.get("IBREFERLINK").toString());
                                let decrpyLinRm1 = decrpyLinRm.split("||");
                                _that.$cookies.set("refLink", window.btoa(decrpyLinRm1[0]), "4y", null, _that.$env_var.cookieSaveUrl);
                                _that.$cookies.set("refRm", window.btoa(decrpyLinRm1[1]), "4y", null, _that.$env_var.cookieSaveUrl);
                                input_json.globalParams.rm_id = _that.$cookies.get("refRm");
                                input_json.globalParams.admin_id = _that.$cookies.get("refLink");
                            }
                            _that._runUserSignUp(input_json);
                            _that.$refs.recaptcha.reset();
                        }
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            verify_lead() {
                const _that = this;
                _that.submittedOtp = true;

                const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let hashedstr = mykey.update(_that.password, "utf8", "hex");
                hashedstr += mykey.final("hex");

                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                email: _that.email,
                                account_type: _that.account_type,
                                mobile: _that.numberWithCountry,
                                password: hashedstr,
                                OTP: _that.otp,
                                // ID: _that.insertId,
                                IBREFERLINK: _that.IBREFERLINK,
                                ip_country: this.userCountry,
                            },
                            localParams: { parameter: _that },
                        };

                        //==not in use===============
                        if (_that.$cookies.get("referralId")) {
                            input_json.globalParams.referralId = _that.$cookies.get("referralId");
                        }
                        if (_that.$cookies.get("investing_ref")) {
                            input_json.globalParams.investing_ref = _that.$cookies.get("investing_ref");
                        }
                        //===========in use==============
                        if (_that.$cookies.get("refLink") && _that.$cookies.get("refRm")) {
                            input_json.globalParams.refLink = _that.$cookies.get("refLink");
                            input_json.globalParams.refRm = _that.$cookies.get("refRm");
                        } else if (_that.$cookies.get("IBREFERLINK")) {
                            let decrpyLinRm = window.atob(_that.$cookies.get("IBREFERLINK").toString());
                            let decrpyLinRm1 = decrpyLinRm.split("||");
                            _that.$cookies.set("refLink", window.btoa(decrpyLinRm1[0]), "4y", null, _that.$env_var.cookieSaveUrl);
                            _that.$cookies.set("refRm", window.btoa(decrpyLinRm1[1]), "4y", null, _that.$env_var.cookieSaveUrl);
                            input_json.globalParams.refLink = _that.$cookies.get("refLink");
                            input_json.globalParams.refRm = _that.$cookies.get("refRm");
                        }

                        try {
                            __adroll.track("pageView", { segment_name: "4cfb31ed" });
                        } catch (err) {}
                        _that._runVerifyLeadOtp(input_json);
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            RemoveNode(iso2) {
                return this.countriesList.filter(function (emp) {
                    if (emp.iso2 == iso2) {
                        return false;
                    }
                    return true;
                });
            },
            countryCookisGet() {
                if (this.$cookies.get("countrySelectedFromWebsite") != undefined) {
                    if (this.$cookies.get("countrySelectedFromWebsite") == "IN") {
                        // this.response_msg = 'you are not allowed to register in this portal'
                        // this.msg_type = 'error'
                    } else {
                        this.res_country = this.$cookies.get("countrySelectedFromWebsite");
                    }
                }
            },
            runVerify() {
                const encyptKey = this.$route.query["verify"];

                let mykey = crypto.createDecipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let mystr = mykey.update(encyptKey, "hex", "utf8");
                mystr += mykey.final("utf8");

                let infoArray = mystr.split("^");

                if (this.IBREFERLINK == "") {
                    this.IBREFERLINK = infoArray[5];
                }
                let input_json = {
                    globalParams: {
                        verify: this.$route.query["verify"],
                        ip_country: this.userCountry,
                    },
                    localParams: { parameter: this },
                };
                this._runVerifyLeadOtp(input_json);
            },
        },
        created() {
            this._runGetCountriesList({
                globalParams: {},
                localParams: { parameter: this, page: "register" },
            });

            if ("verify" in this.$route.query) {
                this._runGetUserIp({
                    globalParams: {
                        verify: true,
                    },
                    localParams: { parameter: this },
                });
            } else {
                this._runGetUserIp({
                    globalParams: {},
                    localParams: { parameter: this },
                });
            }

            //=====================not in use======================
            if (this.$route.query.investing_ref) {
                this.$cookies.set("investing_ref", this.$route.query.investing_ref, "1y", null, this.$env_var.cookieSaveUrl);
            }
            if (this.$route.query.referralLead) {
                this.$cookies.set("referralLead", this.$route.query.referralLead, "1y", null, this.$env_var.cookieSaveUrl);
                this.$router.replace({ query: null });
            }
            //=====================================================

            //=============in use===================
            //console.log('query',this.$route.query)
            if (this.$route.query.refLink && this.$route.query.refRm) {
                //console.log(this.$route.query.refLink,'====>',this.$route.query.refRm)
                this.$cookies.set("refLink", this.$route.query.refLink, "1y", null, this.$env_var.cookieSaveUrl);
                this.$cookies.set("refRm", this.$route.query.refRm, "1y", null, this.$env_var.cookieSaveUrl);
                this.$router.replace({ query: null });
            } else if (this.$cookies.get("IBREFERLINK")) {
                let decrpyLinRm = window.atob(this.$cookies.get("IBREFERLINK").toString());
                let decrpyLinRm1 = decrpyLinRm.split("||");
                this.$cookies.set("refLink", window.btoa(decrpyLinRm1[0]), "1y", null, this.$env_var.cookieSaveUrl);
                this.$cookies.set("refRm", window.btoa(decrpyLinRm1[1]), "1y", null, this.$env_var.cookieSaveUrl, "global.fxview.com,app.fxview.com,partners.fxview.com");
            }
        },
        mounted() {
            const _that = this;
            $(document).on("click", function (event) {
                if (!$(event.target).closest(".tabClass").length) {
                    _that.tabActive = "";
                }
            });

            setTimeout(() => {
                try {
                    let p_countries = { AE: 104607, AR: 104608, AU: 103314, BR: 104609, CA: 104610, DE: 103065, DK: 103066, ES: 103313, IT: 104611, KE: 104612, MA: 104613, NG: 104614, NL: 103061, PE: 104615, PL: 104616, PT: 103312, SA: 104617, SE: 103309, ZA: 104618 };
                    fetch("https://ipapi.co/country?key=WqrqGPQYxfU6ySEZKqlU8bNDk9BgWVez4Uk3L4auzRyosaOWSs")
                        .then((res) => {
                            if (res.ok) {
                                return res.text();
                            } else {
                                throw new Error("HTTP Error " + res.status);
                            }
                        })
                        .then((country) => {
                            if (p_countries[country]) {
                                var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                                var crypto = require("crypto");
                                try {
                                    /*let email = crypto.createHash('md5').update(result.res_data.user.email).digest("hex");*/
                                    // let email = crypto.createHash('md5').update('1').digest("hex")
                                    let setAccount = { event: "setAccount", account: p_countries[country] };
                                    let setEmail = { event: "setEmail", email: "" /*, hash_method: "md5"*/ };
                                    let setSiteType = { event: "setSiteType", type: deviceType };
                                    let viewBasket = { event: "viewBasket", item: [{ id: "registration", price: "1", quantity: "1" }] };
                                    /*console.log('critio-update-viewBasket-before :- ',JSON.stringify([setAccount,setEmail,setSiteType,viewBasket]))*/
                                    window.criteo_q.push(setAccount, setEmail, setSiteType, viewBasket);
                                    /*console.log('critio-update-viewBasket-after :- ',JSON.stringify([setAccount,setEmail,setSiteType,viewBasket]))*/
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } catch (error) {
                    console.log(error);
                }
            }, "3000");
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/fxView/lp/pageSections/register.vue